<template>
  <div v-if="activeSoilType">
    <v-card class="ma-3 pa-5">
      <h3>Soil type information</h3>
      <v-divider/>
       <v-text-field v-model="activeSoilType.name" label="Name"/>
       <v-text-field v-model="activeSoilType.kp" type="number" label="Kp"/>
       <v-text-field v-model="activeSoilType.Erw" type="number" label="Erw"/>
       <v-text-field v-model="activeSoilType.Erj0" type="number" label="Erj0"/>
       <v-text-field v-model="activeSoilType.sp" type="number" label="sp"/>
       <v-text-field v-model="activeSoilType.fc" type="number" label="fc"/>
       <v-text-field v-model="activeSoilType.wp" type="number" label="wp"/>
       <v-text-field v-model="activeSoilType.ssp" type="number" label="ssp"/>
        <v-btn @click="updateSoilTypeInfo" color="primary">Save</v-btn>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "SoilTypeView",
  mounted() {
    this.fetchSoilType(this.$route.params.id)
  },
  methods: {
    ...mapActions('soil',  ['fetchSoilType', 'updateSoilType']),
      updateSoilTypeInfo() {
          if (!Object.values(this.activeSoilType).every(st => st)) {
              alert("Please fill all fields")
              return
          }
          this.updateSoilType()
      }
  },
  computed: {
    ...mapState('soil', ['activeSoilType'])
  },
}

</script>

<style scoped>

</style>